import { render, staticRenderFns } from "./purchase-analysis.vue?vue&type=template&id=7ba35984&scoped=true&"
import script from "./purchase-analysis.vue?vue&type=script&lang=js&"
export * from "./purchase-analysis.vue?vue&type=script&lang=js&"
import style0 from "./purchase-analysis.vue?vue&type=style&index=0&id=7ba35984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba35984",
  null
  
)

export default component.exports